const doc = [({"all_events":"Alla event", "apply":"Tillämpa", "back":"Tillbaka", "bank_wire":"Banköverföring", "code":"Kod"})];
module.exports = doc.length <= 1 ? doc[0] : doc;